import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Nexus } from '@tomandco/nexus-api-types';
import { DfApiConfigService } from './df-api-config.service';

export const countriesListResolver: ResolveFn<Nexus.Api.General.Countries.Response> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    return inject(DfApiConfigService).loadCountries();
};
